export const milestoneTypeConstants = [
  { name: "Primary", value: false },
  { name: "Extra", value: true },
];
